import { render, staticRenderFns } from "./simulationHigh.vue?vue&type=template&id=c47bc37e&scoped=true"
import script from "./simulationHigh.vue?vue&type=script&lang=js"
export * from "./simulationHigh.vue?vue&type=script&lang=js"
import style0 from "./simulationHigh.vue?vue&type=style&index=0&id=c47bc37e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47bc37e",
  null
  
)

export default component.exports